import { createAsyncThunk, createEntityAdapter, createSelector, createSlice, current } from '@reduxjs/toolkit';
import _ from 'lodash';
import { FETCH_STATUS_ENUM } from '../../../../../common/enums/enums';
import { getProductBySku } from '../services/kogan-products-service';

const tabProductsAdaptor = createEntityAdapter({
  selectId: (product) => product.product_sku,
});
const initialState =  tabProductsAdaptor.getInitialState({
    statuses:[],
});
const koganTabProductsSlice = createSlice({
  name: 'koganTabProducts',
  initialState,
  reducers: {
    removeProduct: tabProductsAdaptor.removeOne,
    upsertProduct: tabProductsAdaptor.upsertOne,
    updateStatus: (state,action)=>{
        const {product_sku,status} = action.payload;
        setStatus(state,product_sku,status);
    }

  },
  extraReducers(builder) {
    builder.addCase(fetchProduct.fulfilled,(state,action)=>{
        tabProductsAdaptor.upsertOne(state,action.payload[0]);
        setStatus(state,action.meta.arg,FETCH_STATUS_ENUM.SUCCESS);
    })
    .addCase(fetchProduct.pending,(state,action)=>{
        setStatus(state,action.meta.arg,FETCH_STATUS_ENUM.LOADING);
    })
    .addCase(fetchProduct.rejected,(state,action)=>{
        setStatus(state,action.meta.arg,FETCH_STATUS_ENUM.FAILED);
    })
  },
});

export const {  removeProduct, upsertProduct,updateStatus } =
  koganTabProductsSlice.actions;

export const fetchProduct = createAsyncThunk(
  'koganTabProducts/fetchProduct',
  async (product_sku) => {
    const response = await getProductBySku(product_sku, true);
    return response.data.results;
  }
);

//Define selectors here
export const { selectAll,selectById } = tabProductsAdaptor.getSelectors(
  (state) => state.koganTabProducts
);
export const getActiveTab = (state) => state.koganTabProducts.activeKey;

const getStatuses = (state) =>  state.koganTabProducts.statuses;

export const getProductStatus = createSelector(getStatuses,(state,product_sku)=>product_sku,
    (statuses,product_sku)=>{
       const found = _.find(statuses,status=> status.product_sku===product_sku);
       return found?.status;
    }
);





export default koganTabProductsSlice.reducer;


//internal helper functions
const setStatus=(state,product_sku,status)=>{
    const newStatus = {product_sku,status};
    _.remove(state.statuses, s=> s.product_sku === product_sku);
    state.statuses.push(newStatus);
}